export default function formatWww(website) {
  if (!website) return;
  const replaceHttp = website.replace(/^https\:\/\//, '').replace(/^http\:\/\//, '');
  return new URL('https://'+replaceHttp);
}
